var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrillDownTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,9.1c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5s-0.2-1.1-0.6-1.5C14.9,5.2,14.4,5,13.8,5 c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5s0.2,1.1,0.6,1.5C12.7,8.9,13.2,9.1,13.8,9.1z M13.8,1c1.5,0,3,0.6,4.1,1.7 c1.1,1.1,1.7,2.6,1.7,4.1c0.2,4.7-5.8,11.3-5.8,11.3s-6-6.6-6-11.1c0-1.5,0.6-3,1.7-4.1C10.8,1.6,12.3,1,13.8,1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.5,10.7 3.5,15 1.9,13.4 0.4,14.9 4.4,19 8.6,14.9 7.1,13.4 5.5,15 5.5,10.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 4.4,
    className: "st0",
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 7.2,
    className: "st0",
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 1.8,
    className: "st0",
    width: 2.1,
    height: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrillDownTrip);
export default __webpack_public_path__ + "static/media/drill-down-trip.0085d7ea5505d8d23e3a3d697178e9b9.svg";
export { ForwardRef as ReactComponent };